// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'babel-polyfill'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueLogger from 'vuejs-logger'
const isProduction = process.env.NODE_ENV === 'production'

const options = {
  'isEnabled': true,
  'logLevel': isProduction ? 'error' : 'debug',
  'stringifyArguments': false,
  'showLogLevel': true,
  'showMethodName': true,
  'separator': '|',
  'showConsoleColors': true
}

Vue.use(VueLogger, options)
Vue.mixin({
  methods: {
    /**
     * 開発環境の時のみログを吐き出す
     **/
    logging (log) {
      if (process.env.NODE_ENV !== 'development') {
        return
      }
      console.log(log)
    },
    /**
     * Isumの楽曲プロダクトID
     **/
    getIsumProductId () {
      return 1
    },
    /**
     * その他の楽曲プロダクトID
     **/
    getOtherProductId () {
      return 2
    }
  }
})

Vue.use(Vuetify, {
  theme: {
    primary: '#15c06a',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#b71c1c'
  }
})

Vue.filter('numbers', (value) => {
  let number = value + 1
  if (number < 10) {
    return '0' + number + '.'
  }
  return number + '.'
})

Vue.filter('minutes', (value) => {
  if (!value || typeof value !== 'number') return '00:00'
  let min = parseInt(value / 60)
  let sec = parseInt(value % 60)
  min = min < 10 ? '0' + min : min
  sec = sec < 10 ? '0' + sec : sec
  value = min + ':' + sec
  return value
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js